import { BehaviorSubject, Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, switchMap, mergeMap, filter, first } from 'rxjs/operators';
import { RefreshTokenProvider } from './refresh-token.provider';
import { TokenProvider } from './token-provider';
import { TokenRefreshToken } from './models';
import { NavController } from '@ionic/angular';
import { LOGIN } from '@symphony-solo/shared/utils/src';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  constructor(private refreshTokenProvider: RefreshTokenProvider, private tokenProvider: TokenProvider, private navCtrl: NavController) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.tokenProvider.getToken().pipe(
      mergeMap((token: TokenRefreshToken) => {
        return next.handle(request).pipe(
          catchError((error) => {
            if (error.status !== 401) {
              throw error;
            }

            if (error.status === 400) {
              localStorage.clear();
              this.navCtrl.navigateRoot(LOGIN);
              throw error;
            }

            if (this.refreshTokenInProgress) {
              return this.refreshTokenSubject.pipe(
                filter((result) => result !== null),
                first(),
                switchMap((t) => next.handle(this.addTokenToRequestHeader(request, t)))
              );
            } else {
              this.refreshTokenInProgress = true;
              this.refreshTokenSubject.next(null);

              return this.refreshTokenProvider.refreshToken(token).pipe(
                switchMap((t: string) => {
                  this.refreshTokenInProgress = false;
                  this.refreshTokenSubject.next(t);
                  return next.handle(this.addTokenToRequestHeader(request, t));
                }),
                catchError((e) => {
                  console.log('refreshToken API Call catchError: ', token);
                  this.refreshTokenInProgress = false;
                  throw e;
                })
              );
            }
          })
        );
      })
    );
  }

  private addTokenToRequestHeader(request, token) {
    return request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
      },
    });
  }
}
